import {
  ExtraWorkedTimeRequestStatus,
  ExtraWorkedTimeRequestStatusUpdater,
} from "@src/appV2/Shifts/MandatoryBreakPolicy/api/useExtraWorkedTimeRequests";
import { ExtraWorkedTimeType } from "@src/appV2/Shifts/Shift/types";
import { z } from "zod";

// NOTE: Local copy of extraWorkedTimeRequestEntitySchema with `end` made optional.
// BLOCKED: Replace with extraWorkedTimeRequestEntitySchema once `end` is optional upstream.
export const fullShiftExtraWorkedTimeRequestEntitySchema = z.object({
  id: z.string(),
  type: z.literal("ExtraWorkedTimeRequest"),
  attributes: z.object({
    type: z.nativeEnum(ExtraWorkedTimeType),
    agentId: z.string(),
    facilityId: z.string(),
    shiftId: z.string(),
    reason: z.string(),
    start: z.string(),
    end: z.string().optional(), // not present on full-shift requests
    breakStartEnd: z
      .object({ start: z.string().optional(), end: z.string().optional() })
      .optional(),
    timeRequestedInMinutes: z.number().optional(),
    statusUpdatedBy: z.nativeEnum(ExtraWorkedTimeRequestStatusUpdater).optional(),
    statusUpdateReason: z.string().nullish(),
    status: z.nativeEnum(ExtraWorkedTimeRequestStatus),
    createdAt: z.string(),
    updatedAt: z.string(),
    isFullShiftPayment: z.boolean().optional(),
  }),
  meta: z
    .object({
      computedPay: z.number().optional(),
      computedCharge: z.number().optional(),
      computedExpirationTime: z.string().optional(),
      isNotificationDismissed: z.boolean().optional(),
      isOutcomeAcknowledged: z.boolean().optional(),
    })
    .optional(),
});

export type FullShiftExtraWorkedTimeRequestEntity = z.infer<
  typeof fullShiftExtraWorkedTimeRequestEntitySchema
>;
